var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.showPreferentialInstruction ? _c('div', {
    staticClass: "component-preferential-instruction"
  }, [_c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("特殊说明")]), _c('div', {
    staticClass: "package-content",
    class: {
      'no-viewmore': !_vm.showMoreVisible
    }
  }, [_vm._l(_vm.particalList, function (item, index) {
    return [_c('div', {
      key: index,
      staticClass: "item",
      class: {
        'show-viewmore': _vm.showMoreVisible
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('span', {
      staticClass: "title-text"
    }, [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "item-detail"
    }, _vm._l(_vm.formatContent(item.desc), function (content, index) {
      return _c('p', {
        key: index,
        staticClass: "desc"
      }, [_vm._v(_vm._s(content))]);
    }), 0)])];
  })], 2), _vm.showMoreVisible ? _c('div', {
    staticClass: "btn-viewmore"
  }, [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.showMoreList();
      }
    }
  }, [_vm._v("查看全部")]), _c('ycf-image', {
    staticClass: "arrow-down",
    attrs: {
      "src": require("../../assets/img/arrow-down@2x.png")
    }
  })], 1) : _vm._e()])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };